<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2020 by Ellen Prager</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2020</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">29 28 27 26 25 24 23 22 21 20    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-54169-3 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-54172-3 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226541723.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226541723.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Prager, Ellen J., author.</p>
<p class="cip">Title: Dangerous Earth : what we wish we knew about volcanoes, hurricanes, climate change, earthquakes, and more / Ellen Prager.</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2020. | Includes bibliographical references.</p>
<p class="cip">Identifiers: LCCN 2019025458 | ISBN 9780226541693 (cloth) | ISBN 9780226541723 (ebook)</p>
<p class="cip">Subjects: LCSH: Natural disasters. | Climatic changes. | Hazard mitigation.</p>
<p class="cip">Classification: LCC GB5014 .P73 2020 | DDC 551—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2019025458" target="_blank">https://lccn.loc.gov/2019025458</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-prager-0004.vue?d825844a